import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { colors } from '../../../constants/colors';
import { fontFamily, fontSize } from '../../../constants/text';

const Root = styled.div`
  text-align: center;
  padding: 30px 0;
  background-color: ${colors.whiteGrey};
  border-bottom: 1px solid ${colors.dorianGrey};
`;

const Banner = styled.h3`
  margin: 0 auto;
  font-size: ${fontSize.extraLarge};
  font-family: ${fontFamily.bold};
  color: ${colors.crunchBerry};
  text-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
`;

const SubText = styled.h4`
  display: inline-block;
  margin: 0 auto;
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.book};
  color: ${colors.blueMonday};
  letter-spacing: 0.13px;
  text-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  padding-top: 14px;
`;

export default class ThanksForFeedbackHeader extends PureComponent {
  render = () => (
    <Root>
      <Banner>Thanks for Your Feedback!</Banner>
      <SubText>Before we can publish your review, you need to sign up or log in.</SubText>
    </Root>
  );
}
